<ejs-tab #element id="element" heightAdjustMode='Auto' width="'100%'" (click)="checkTabSelection()">
  <e-tabitems>
    <e-tabitem [header]='{ text: "API Data Subscription" }'>
      <ng-template #content>
	  
      </ng-template>
    </e-tabitem>
  </e-tabitems>
</ejs-tab>


<div id="map-div">
  <ejs-maps id="maps-container"
            [zoomSettings]="zoomSettings"
            [centerPosition]="{
              latitude: 25,
              longitude: -89
            }" width="100%" height="100%">
    <e-layers>
      <e-layer [shapeData]='shapeData'></e-layer>
    </e-layers>
  </ejs-maps>
</div>
